import React, { useContext, useState, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import { sendCommand } from "../../../util/util";
import { Text, Button, Logo, RowContainer } from "../style";
import werewolf from "../../../static/werewolf.svg";
import withTurn from "..";
import ChatArea from "../../ChatArea";

const WereWolf = () => {
  const { username, members, websocket } = useContext(AppContext);
  const [done, setDone] = useState(false);

  useEffect(() => {
    setDone(false);
    return () => {
      setDone(false);
    };
  }, [setDone]);

  return (
    <>
      <RowContainer>
        <Logo src={werewolf} alt="logo" />
        <Text>You're a WereWolf</Text>
        {done ? (
          <Text>One person is enough for one night :)</Text>
        ) : (
          <>
            <Text>Select who you want to eat tonight</Text>
            {members
              .filter((member) => member !== username)
              .map((member) => (
                <Button
                  key={member}
                  onClick={() => {
                    sendCommand(websocket, "kill", member);
                    setDone(true);
                  }}
                >
                  {member}
                </Button>
              ))}
          </>
        )}
      </RowContainer>

      <ChatArea />
    </>
  );
};

export default withTurn(WereWolf);
